import { gpcListener } from './lib';

gpcListener();
